import { getSuiteApiBase, getSuiteAppUrl } from "@/auth/paths";
import { mailAuthHeaders } from "@/auth/session";

export type SuiteApiResult<T = Record<string, unknown>> = {
  ok: boolean;
  status: number;
  data: T;
};

export async function suiteApiFetch<T = Record<string, unknown>>(
  path: string,
  init: RequestInit = {}
): Promise<SuiteApiResult<T>> {
  const url = `${getSuiteApiBase()}/${path.replace(/^\//, "")}`;
  const res = await fetch(url, {
    credentials: "include",
    cache: "no-store",
    ...init,
    headers: {
      ...mailAuthHeaders(),
      ...(init.headers as Record<string, string> | undefined),
    },
  });

  const data = (await res.json().catch(() => ({}))) as T;
  return {
    ok: res.ok && (data as { success?: boolean }).success !== false,
    status: res.status,
    data,
  };
}

export { getSuiteAppUrl };
